// Keep the value consistent with that in api
export const Privilege = {
  NEW_TASK: 'NEW_TASK',
  NEW_TASK_KENSHIN: 'NEW_TASK_KENSHIN',
  ORGANIZATION_TASK_MANAGEMENT: 'ORGANIZATION_TASK_MANAGEMENT',
  ORGANIZATION_TASK_MANAGEMENT_KENSHIN: 'ORGANIZATION_TASK_MANAGEMENT_KENSHIN',
  ORGANIZATION_TASK_LIST: 'ORGANIZATION_TASK_LIST',
  ORGANIZATION_TASK_LIST_KENSHIN: 'ORGANIZATION_TASK_LIST_KENSHIN',
  BILLING: 'BILLING',
  BILLING_RECEIVED_TASKS: 'BILLING_RECEIVED_TASK',
  BILLING_SENT_TASKS: 'BILLING_SENT_TASK',
  ORGANIZATION_MANAGEMENT: 'ORGANIZATION_MANAGEMENT',
  ORGANIZATION_SETTINGS: 'ORGANIZATION_SETTINGS',
  CONTRACT_MANAGEMENT: 'CONTRACT_MANAGEMENT',
  EMPLOYMENT_MANAGEMENT: 'EMPLOYMENT_MANAGEMENT',
  TAG_TEMPLATE_MANAGEMENT: 'TAG_TEMPLATE_MANAGEMENT',
  ACTIVITIES_LOG_MANAGEMENT: 'ACTIVITIES_LOG_MANAGEMENT',
  PERSON_IN_CHARGE_AS_STAFF: 'PERSON_IN_CHARGE_AS_STAFF',
  PERSON_IN_CHARGE_AS_DOCTOR: 'PERSON_IN_CHARGE_AS_DOCTOR',
  AI_SUMMARY: 'AI_SUMMARY',
  SEIMITSU_VIEWER: 'SEIMITSU_VIEWER',
  SEIMITSU_ISSUE_DELETION: 'SEIMITSU_ISSUE_DELETION',

  //! The following 2 are only used in iwg admin
  ORGANIZATION_RECEIVED_LIST: 'ORGANIZATION_RECEIVED_LIST',
  ORGANIZATION_SENT_LIST: 'ORGANIZATION_SENT_LIST',
  ORGANIZATION_RECEIVED_LIST_KENSHIN: 'ORGANIZATION_RECEIVED_LIST_KENSHIN',
  ORGANIZATION_SENT_LIST_KENSHIN: 'ORGANIZATION_SENT_LIST_KENSHIN',
};

export const SwitchLabelForStaff = {
  NEW_TASK: Privilege.NEW_TASK,
  NEW_TASK_KENSHIN: Privilege.NEW_TASK_KENSHIN,
  ORGANIZATION_TASK_MANAGEMENT: Privilege.ORGANIZATION_TASK_MANAGEMENT,
  ORGANIZATION_TASK_MANAGEMENT_KENSHIN:
    Privilege.ORGANIZATION_TASK_MANAGEMENT_KENSHIN,
  BILLING: Privilege.BILLING,
  AI_SUMMARY: Privilege.AI_SUMMARY,
  SEIMITSU_VIEWER: Privilege.SEIMITSU_VIEWER,
  SEIMITSU_ISSUE_DELETION: Privilege.SEIMITSU_ISSUE_DELETION,
};

export const SwitchLabelForDoctor = {
  NEW_TASK: Privilege.NEW_TASK,
  NEW_TASK_KENSHIN: Privilege.NEW_TASK_KENSHIN,
  ORGANIZATION_TASK_MANAGEMENT: Privilege.ORGANIZATION_TASK_MANAGEMENT,
  ORGANIZATION_TASK_MANAGEMENT_KENSHIN:
    Privilege.ORGANIZATION_TASK_MANAGEMENT_KENSHIN,
  BILLING: Privilege.BILLING,
  AI_SUMMARY: Privilege.AI_SUMMARY,
  SEIMITSU_VIEWER: Privilege.SEIMITSU_VIEWER,
  SEIMITSU_ISSUE_DELETION: Privilege.SEIMITSU_ISSUE_DELETION,
};

export const SwitchLabel = {
  NEW_TASK: Privilege.NEW_TASK,
  NEW_TASK_KENSHIN: Privilege.NEW_TASK_KENSHIN,
  ORGANIZATION_TASK_MANAGEMENT: Privilege.ORGANIZATION_TASK_MANAGEMENT,
  ORGANIZATION_TASK_MANAGEMENT_KENSHIN:
    Privilege.ORGANIZATION_TASK_MANAGEMENT_KENSHIN,
  BILLING: Privilege.BILLING,
  PERSON_IN_CHARGE_AS_STAFF: Privilege.PERSON_IN_CHARGE_AS_STAFF,
  PERSON_IN_CHARGE_AS_DOCTOR: Privilege.PERSON_IN_CHARGE_AS_DOCTOR,
  AI_SUMMARY: Privilege.AI_SUMMARY,
  SEIMITSU_VIEWER: Privilege.SEIMITSU_VIEWER,
  SEIMITSU_ISSUE_DELETION: Privilege.SEIMITSU_ISSUE_DELETION,
};

export const SwitchLabelToPrivilege = {
  [SwitchLabel.NEW_TASK]: [Privilege.NEW_TASK],
  [SwitchLabel.NEW_TASK_KENSHIN]: [Privilege.NEW_TASK_KENSHIN],
  [SwitchLabel.ORGANIZATION_TASK_MANAGEMENT]: [
    Privilege.ORGANIZATION_TASK_MANAGEMENT,
    Privilege.ORGANIZATION_TASK_LIST,
    Privilege.ORGANIZATION_RECEIVED_LIST,
    Privilege.ORGANIZATION_SENT_LIST,
  ],
  [SwitchLabel.ORGANIZATION_TASK_MANAGEMENT_KENSHIN]: [
    Privilege.ORGANIZATION_TASK_MANAGEMENT_KENSHIN,
    Privilege.ORGANIZATION_TASK_LIST_KENSHIN,
    Privilege.ORGANIZATION_RECEIVED_LIST_KENSHIN,
    Privilege.ORGANIZATION_SENT_LIST_KENSHIN,
  ],
  [SwitchLabel.BILLING]: [
    Privilege.BILLING,
    Privilege.BILLING_RECEIVED_TASKS,
    Privilege.BILLING_SENT_TASKS,
  ],
  [SwitchLabel.ORGANIZATION_MANAGEMENT]: [
    Privilege.ORGANIZATION_MANAGEMENT,
    Privilege.ORGANIZATION_SETTINGS,
    Privilege.CONTRACT_MANAGEMENT,
    Privilege.EMPLOYMENT_MANAGEMENT,
    Privilege.TAG_TEMPLATE_MANAGEMENT,
    Privilege.ACTIVITIES_LOG_MANAGEMENT,
  ],
  [SwitchLabel.PERSON_IN_CHARGE_AS_STAFF]: [
    Privilege.PERSON_IN_CHARGE_AS_STAFF,
  ],
  [SwitchLabel.PERSON_IN_CHARGE_AS_DOCTOR]: [
    Privilege.PERSON_IN_CHARGE_AS_DOCTOR,
  ],
  [SwitchLabel.AI_SUMMARY]: [Privilege.AI_SUMMARY],
  [SwitchLabel.SEIMITSU_VIEWER]: [Privilege.SEIMITSU_VIEWER],
  [SwitchLabel.SEIMITSU_ISSUE_DELETION]: [Privilege.SEIMITSU_ISSUE_DELETION],
};

export const SwitchLableToTranslationKey = {
  [SwitchLabel.NEW_TASK]:
    'organization_settings_user_management_modal_label_new_task',
  [SwitchLabel.NEW_TASK_KENSHIN]:
    'organization_settings_user_management_modal_label_new_task_kenshin',
  [SwitchLabel.ORGANIZATION_TASK_MANAGEMENT]:
    'organization_settings_user_management_modal_label_organization_task_management',
  [SwitchLabel.ORGANIZATION_TASK_MANAGEMENT_KENSHIN]:
    'organization_settings_user_management_modal_label_organization_task_management_kenshin',
  [SwitchLabel.BILLING]:
    'organization_settings_user_management_modal_label_billing',
  [SwitchLabel.PERSON_IN_CHARGE_AS_STAFF]:
    'organization_settings_user_management_modal_label_pic_as_staff',
  [SwitchLabel.PERSON_IN_CHARGE_AS_DOCTOR]:
    'organization_settings_user_management_modal_label_pic_as_doctor',
  [SwitchLabel.AI_SUMMARY]:
    'organization_settings_user_management_modal_label_ai_summary',
  [SwitchLabel.SEIMITSU_VIEWER]:
    'organization_settings_user_management_modal_label_seimitsu_viewer',
  [SwitchLabel.SEIMITSU_ISSUE_DELETION]:
    'organization_settings_user_management_modal_label_seimitsu_issue_deletion',
};

export const PrivilegeStatus = {
  ON: 'ON',
  OFF: 'OFF',
};
